export interface IQueueJobState {
    nameTech: string;
    label: string;
    retry: boolean;
    cancel: boolean;
    color?: string;
    fill?: string;
    inProgress?: boolean;
    isRecurringOption: string;
    showInFilter?: boolean;
}


export const ALL_STATES: IQueueJobState[] = [
    {
        nameTech: 'START__QUEUED_FOR_RETRY',
        label: 'Queued',
        retry: false,
        color: '#b2ddcc',
        fill: '#b2ddcc',
        cancel: true,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'START__NEW_PENDING',
        label: 'New',
        color: '#b2ddcc',
        fill: '#b2ddcc',
        retry: false,
        cancel: true,
        showInFilter: true,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'START__RECURRING_REQUEUED',
        label: 'Active',
        color: '#b2ddcc',
        fill: '#b2ddcc',
        retry: false,
        showInFilter: true,
        cancel: true,
        isRecurringOption: 'Yes'
    },
    {
        nameTech: 'PROCESS__INIT_PASSED__PRE_RUN_CHECK_IS_IN_PROGRESS',
        label: 'Checking',
        color: 'warning',
        fill: '#fb8c00',
        retry: true,
        cancel: true,
        inProgress: true,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS__PRE_RUN_CHECK_PASSED__RUN_IS_IN_PROGRESS',
        label: 'In progress',
        color: 'warning',
        fill: '#fb8c00',
        retry: true,
        showInFilter: true,
        cancel: true,
        inProgress: true,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS__RUN_PASSED__VERIFY_IS_IN_PROGRESS',
        label: 'Verifying',
        color: 'warning',
        fill: '#fb8c00',
        retry: true,
        cancel: true,
        inProgress: true,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS_ERROR__INIT_FAILED',
        label: 'Failed',
        color: 'error',
        fill: '#ff5252',
        retry: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS_ERROR__PRE_RUN_CHECK_FAILED',
        label: 'Check failed',
        color: 'error',
        fill: '#ff5252',
        showInFilter: true,
        retry: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS_ERROR__RUN_FAILED',
        label: 'Run failed',
        color: 'error',
        fill: '#ff5252',
        retry: true,
        showInFilter: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'PROCESS_ERROR__VERIFY_FAILED',
        label: 'Verification failed',
        color: 'error',
        fill: '#ff5252',
        retry: true,
        showInFilter: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'ERROR__CONFLICTING_WITH_OTHER_JOB',
        label: 'Conflict',
        color: 'error',
        fill: '#ff5252',
        retry: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'ERROR__INTERRUPTED',
        label: 'Interrupted',
        color: 'error',
        fill: '#ff5252',
        retry: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
    {
        nameTech: 'ERROR__CANCELED',
        label: 'Canceled',
        color: 'grey',
        fill: '#ff5252',
        retry: true,
        showInFilter: true,
        cancel: false,
        isRecurringOption: 'No'
    },
    {
        nameTech: 'RECURRING__PAUSED',
        label: 'Paused',
        color: 'warning',
        fill: '#fb8c00',
        retry: true,
        cancel: false,
        isRecurringOption: 'Yes'
    },
    {
        nameTech: 'DONE__VERIFY_PASSED',
        label: 'Passed',
        color: 'success',
        fill: '#4caf50',
        showInFilter: true,
        retry: true,
        cancel: false,
        isRecurringOption: 'Both'
    },
];